import {
  CloseSquare,
  Done,
  FileFill,
  LightningFill,
  RefundBackLight,
  RoadDocLightCustom,
  RoadFillCustom,
} from '@repo/go-icons';
import { Button, Checkbox, Drawer } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import BulldozerIcon from 'src/shared/assets/icons/bulldozer.svg';

import type { WellPadPreparationFilterStore } from '../../well-pad-preparation-filter.store';
import { defaultFilterData } from '../../well-pad-preparation-filter.store';

import styles from './well-pad-preparation-filter.module.scss';

type Props = {
  isOpen: boolean;
  filterStore: WellPadPreparationFilterStore;
  onClose: VoidFunction;
};

export const WellPadPreparationFilter = observer<Props>(function WellPadPreparationFilter({
  isOpen,
  filterStore,
  onClose,
}) {
  const { t } = useTranslation();
  const [filtersState, setFiltersState] = useState(filterStore.filterData);

  const handleResetFilters = () => {
    setFiltersState(defaultFilterData);
    filterStore.updateFilterData(defaultFilterData);
    onClose();
  };

  const handleApply = () => {
    filterStore.updateFilterData(filtersState);
    onClose();
  };

  // TODO: сделать нормальную вёрстку без такого дублирования кода

  return (
    <Drawer
      open={isOpen}
      title={
        <div className={styles.headerWrapper}>
          <h2>{t('wellPadPreparation:Labels.compositionOfPreparation')}</h2>
          <Button className={styles.closeButton} variant="flat" icon={<CloseSquare />} onClick={onClose} />
        </div>
      }
      className={styles.sidebar}
      closeIcon={null}
    >
      <div className={styles.wrapper}>
        <div className={styles.filterWrapper}>
          <div className={styles.filterHeaderWrapper}>
            <BulldozerIcon className={styles.icon} />
            <h3 className={styles.filterHeaderText}>{t('wellPadPreparation:Labels.padReadiness')}</h3>
          </div>
          <div className={styles.filterOptionsWrapper}>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.padReadiness.notReady}
                onChange={(value) =>
                  setFiltersState((state) => ({ ...state, padReadiness: { ...state.padReadiness, notReady: value } }))
                }
              />
              <p>{t('labels:notReady')}</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.padReadiness.ready}
                onChange={(value) =>
                  setFiltersState((state) => ({ ...state, padReadiness: { ...state.padReadiness, ready: value } }))
                }
              />
              <p>{t('labels:ready')}</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.padReadiness.inProcess}
                onChange={(value) =>
                  setFiltersState((state) => ({ ...state, padReadiness: { ...state.padReadiness, inProcess: value } }))
                }
              />
              <p>{t('labels:inProcess')}</p>
            </label>
          </div>
        </div>

        <div className={styles.filterWrapper}>
          <div className={styles.filterHeaderWrapper}>
            <FileFill className={styles.icon} />
            <h3 className={styles.filterHeaderText}>{t('wellPadPreparation:Labels.padDocumentationReadiness')}</h3>
          </div>
          <div className={styles.filterOptionsWrapper}>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.padDocumentationReadiness.notReady}
                onChange={(value) =>
                  setFiltersState((state) => ({
                    ...state,
                    padDocumentationReadiness: { ...state.padDocumentationReadiness, notReady: value },
                  }))
                }
              />
              <p>{t('labels:notReady')}</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.padDocumentationReadiness.ready}
                onChange={(value) =>
                  setFiltersState((state) => ({
                    ...state,
                    padDocumentationReadiness: { ...state.padDocumentationReadiness, ready: value },
                  }))
                }
              />
              <p>{t('labels:ready')}</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.padDocumentationReadiness.inProcess}
                onChange={(value) =>
                  setFiltersState((state) => ({
                    ...state,
                    padDocumentationReadiness: { ...state.padDocumentationReadiness, inProcess: value },
                  }))
                }
              />
              <p>{t('labels:inProcess')}</p>
            </label>
          </div>
        </div>

        <div className={styles.filterWrapper}>
          <div className={styles.filterHeaderWrapper}>
            <RoadFillCustom className={styles.icon} />
            <h3 className={styles.filterHeaderText}>{t('wellPadPreparation:Labels.routeReadiness')}</h3>
          </div>
          <div className={styles.filterOptionsWrapper}>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.routeReadiness.notReady}
                onChange={(value) =>
                  setFiltersState((state) => ({
                    ...state,
                    routeReadiness: { ...state.routeReadiness, notReady: value },
                  }))
                }
              />
              <p>{t('labels:notReady')}</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.routeReadiness.ready}
                onChange={(value) =>
                  setFiltersState((state) => ({ ...state, routeReadiness: { ...state.routeReadiness, ready: value } }))
                }
              />
              <p>{t('labels:ready')}</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.routeReadiness.inProcess}
                onChange={(value) =>
                  setFiltersState((state) => ({
                    ...state,
                    routeReadiness: { ...state.routeReadiness, inProcess: value },
                  }))
                }
              />
              <p>{t('labels:inProcess')}</p>
            </label>
          </div>
        </div>

        <div className={styles.filterWrapper}>
          <div className={styles.filterHeaderWrapper}>
            <RoadDocLightCustom className={styles.icon} />
            <h3 className={styles.filterHeaderText}>{t('wellPadPreparation:Labels.routeDocumentationReadiness')}</h3>
          </div>
          <div className={styles.filterOptionsWrapper}>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.routeDocumentationReadiness.notReady}
                onChange={(value) =>
                  setFiltersState((state) => ({
                    ...state,
                    routeDocumentationReadiness: { ...state.routeDocumentationReadiness, notReady: value },
                  }))
                }
              />
              <p>{t('labels:notReady')}</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.routeDocumentationReadiness.ready}
                onChange={(value) =>
                  setFiltersState((state) => ({
                    ...state,
                    routeDocumentationReadiness: { ...state.routeDocumentationReadiness, ready: value },
                  }))
                }
              />
              <p>{t('labels:ready')}</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.routeDocumentationReadiness.inProcess}
                onChange={(value) =>
                  setFiltersState((state) => ({
                    ...state,
                    routeDocumentationReadiness: { ...state.routeDocumentationReadiness, inProcess: value },
                  }))
                }
              />
              <p>{t('labels:inProcess')}</p>
            </label>
          </div>
        </div>

        <div className={styles.filterWrapper}>
          <div className={styles.filterHeaderWrapper}>
            <LightningFill className={styles.icon} />
            <h3 className={styles.filterHeaderText}>{t('wellPadPreparation:Labels.electricityReadiness')}</h3>
          </div>
          <div className={styles.filterOptionsWrapper}>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.electricityReadiness.notReady}
                onChange={(value) =>
                  setFiltersState((state) => ({
                    ...state,
                    electricityReadiness: { ...state.electricityReadiness, notReady: value },
                  }))
                }
              />
              <p>{t('labels:notReady')}</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.electricityReadiness.ready}
                onChange={(value) =>
                  setFiltersState((state) => ({
                    ...state,
                    electricityReadiness: { ...state.electricityReadiness, ready: value },
                  }))
                }
              />
              <p>{t('labels:ready')}</p>
            </label>
            <label className={styles.filterOptionWrapper}>
              <Checkbox
                checked={filtersState.electricityReadiness.inProcess}
                onChange={(value) =>
                  setFiltersState((state) => ({
                    ...state,
                    electricityReadiness: { ...state.electricityReadiness, inProcess: value },
                  }))
                }
              />
              <p>{t('labels:inProcess')}</p>
            </label>
          </div>
        </div>

        <div className={styles.buttonsWrapper}>
          <Button className={styles.button} icon={<RefundBackLight />} onClick={handleResetFilters}>
            {t('common:Buttons.reset')}
          </Button>
          <Button className={styles.button} icon={<Done />} variant="success" onClick={handleApply}>
            {t('common:Buttons.apply')}
          </Button>
        </div>
      </div>
    </Drawer>
  );
});
